/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrganizationOptimizationPreferencesDtoBase
 * auto generated base class for the model OrganizationOptimizationPreferencesDtoModel.
 */
export const OrganizationOptimizationPreferencesDtoModelBase = ModelBase
  .named('OrganizationOptimizationPreferencesDto')
  .props({
    __typename: types.optional(types.literal("OrganizationOptimizationPreferencesDto"), "OrganizationOptimizationPreferencesDto"),
    projectId: types.union(types.undefined, types.null, types.integer),
    userId: types.union(types.undefined, types.null, types.integer),
    squashDuration: types.union(types.undefined, types.null, types.integer),
    transportationMode: types.union(types.undefined, types.null, types.string),
    minimizeRoutes: types.union(types.undefined, types.null, types.boolean),
    swapRoutes: types.union(types.undefined, types.null, types.boolean),
    walkingDeliverySolver: types.union(types.undefined, types.null, types.boolean),
    timeOfDayEta: types.union(types.undefined, types.null, types.boolean),
    flexibleStartTime: types.union(types.undefined, types.null, types.boolean),
    gaSolver: types.union(types.undefined, types.null, types.boolean),
    excludeTolls: types.union(types.undefined, types.null, types.boolean),
    excludeFerry: types.union(types.undefined, types.null, types.boolean),
    timeBalance: types.union(types.undefined, types.null, types.boolean),
    visitBalance: types.union(types.undefined, types.null, types.boolean),
    defaultOrderDuration: types.union(types.undefined, types.null, types.integer),
    useTerritories: types.union(types.undefined, types.null, types.boolean),
    allowCapacityOverload: types.union(types.undefined, types.null, types.boolean),
    allowShiftViolation: types.union(types.undefined, types.null, types.boolean),
    allowTimeWindowViolation: types.union(types.undefined, types.null, types.boolean),
    /** When on, an order's service must finish inside its time window (the latest start becomes window end minus duration). When off, arriving inside the window is enough. */
    finishWithinTimeWindow: types.union(types.undefined, types.null, types.boolean),
    useGaFinalTsp: types.union(types.undefined, types.null, types.boolean),
    id: types.identifier,
    organizationId: types.union(types.undefined, types.integer),
    createdAt: types.union(types.undefined, types.string),
    updatedAt: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrganizationOptimizationPreferencesDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  get userId() { return this.__attr(`userId`) }
  get squashDuration() { return this.__attr(`squashDuration`) }
  get transportationMode() { return this.__attr(`transportationMode`) }
  get minimizeRoutes() { return this.__attr(`minimizeRoutes`) }
  get swapRoutes() { return this.__attr(`swapRoutes`) }
  get walkingDeliverySolver() { return this.__attr(`walkingDeliverySolver`) }
  get timeOfDayEta() { return this.__attr(`timeOfDayEta`) }
  get flexibleStartTime() { return this.__attr(`flexibleStartTime`) }
  get gaSolver() { return this.__attr(`gaSolver`) }
  get excludeTolls() { return this.__attr(`excludeTolls`) }
  get excludeFerry() { return this.__attr(`excludeFerry`) }
  get timeBalance() { return this.__attr(`timeBalance`) }
  get visitBalance() { return this.__attr(`visitBalance`) }
  get defaultOrderDuration() { return this.__attr(`defaultOrderDuration`) }
  get useTerritories() { return this.__attr(`useTerritories`) }
  get allowCapacityOverload() { return this.__attr(`allowCapacityOverload`) }
  get allowShiftViolation() { return this.__attr(`allowShiftViolation`) }
  get allowTimeWindowViolation() { return this.__attr(`allowTimeWindowViolation`) }
  get finishWithinTimeWindow() { return this.__attr(`finishWithinTimeWindow`) }
  get useGaFinalTsp() { return this.__attr(`useGaFinalTsp`) }
  get id() { return this.__attr(`id`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get updatedAt() { return this.__attr(`updatedAt`) }
}
export function selectFromOrganizationOptimizationPreferencesDto() {
  return new OrganizationOptimizationPreferencesDtoModelSelector()
}

export const organizationOptimizationPreferencesDtoModelPrimitives = selectFromOrganizationOptimizationPreferencesDto().projectId.userId.squashDuration.transportationMode.minimizeRoutes.swapRoutes.walkingDeliverySolver.timeOfDayEta.flexibleStartTime.gaSolver.excludeTolls.excludeFerry.timeBalance.visitBalance.defaultOrderDuration.useTerritories.allowCapacityOverload.allowShiftViolation.allowTimeWindowViolation.finishWithinTimeWindow.useGaFinalTsp.organizationId.createdAt.updatedAt
